import { Icon } from '@/components/Icon/Icon';
import { cn } from '@/lib/utils';
import { Tenant } from '@/server/api/schemas/tenant.types';
import { useTranslations } from 'next-intl';
import React from 'react';

const TenantDropDownItem = ({
  onClickTenant,
  isSelected,
  isDefault,
  name,
}: {
  onClickTenant: (key: string | undefined) => void;
  isSelected?: boolean;
  isDefault?: boolean;
  name: string;
}) => {
  const t = useTranslations();
  return (
    <div
      className="flex cursor-pointer items-center justify-between gap-200 bg-colors-backgrounds-primary p-200 hover:bg-colors-backgrounds-neutral-light"
      onClick={() => onClickTenant(undefined)}
      data-testid="filter-option"
    >
      <div className="flex gap-200">
        <p className="label-medium text-colors-content-primary">{name}</p>
        {isDefault && (
          <p className="label-medium text-colors-content-tertiary">
            {t('common_default')}
          </p>
        )}
      </div>
      {isSelected && (
        <Icon
          icon="Check"
          className="h-500 w-500 text-colors-backgrounds-brand"
        />
      )}
    </div>
  );
};

export const TenantDropdown = ({
  tenants,
  selectedTenantId,
  onClickTenant,
}: {
  tenants: Tenant[];
  onClickTenant: (key: string | undefined) => void;
  selectedTenantId: string | undefined;
}) => {
  const t = useTranslations();

  return (
    <div
      className={cn(
        'shadow-lg absolute bottom-0 left-[100px] mb-200 block max-h-[320px] w-8000 overflow-y-auto rounded-200 border border-colors-borders-secondary bg-colors-backgrounds-primary py-100',
      )}
    >
      <TenantDropDownItem
        key="home"
        name={t('navigation_home')}
        onClickTenant={() => onClickTenant(undefined)}
        isDefault
      />
      {tenants.length > 0 ? (
        tenants.map((item) => (
          <TenantDropDownItem
            key={item.id}
            name={item.name}
            isSelected={selectedTenantId === item.id}
            onClickTenant={() => onClickTenant(item.id)}
          />
        ))
      ) : (
        <p className="label-medium bg-colors-backgrounds-primary p-200 text-colors-content-primary">
          {t('common_notResultsFound')}
        </p>
      )}
    </div>
  );
};
